import { render, staticRenderFns } from "./SmallLoginForm.vue?vue&type=template&id=6693fbd5&scoped=true&"
import script from "./SmallLoginForm.vue?vue&type=script&lang=js&"
export * from "./SmallLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoginForm.vue?vue&type=style&index=0&id=6693fbd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6693fbd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VForm,VSpacer,VTextField})
